import { render, staticRenderFns } from "./UserPreview.vue?vue&type=template&id=7a8d2969&scoped=true"
import script from "./UserPreview.vue?vue&type=script&lang=js"
export * from "./UserPreview.vue?vue&type=script&lang=js"
import style0 from "./UserPreview.vue?vue&type=style&index=0&id=7a8d2969&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8d2969",
  null
  
)

export default component.exports